import React from 'react';
import { FileQuestionMark } from 'lucide-react';
import { Empty, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle } from 'components/ui/empty';

const EmptyCard = ({ className }) => {
  return (
    <Empty className={className}>
      <EmptyHeader>
        <EmptyMedia variant="icon" className="rounded-full w-[100px] h-[100px] bg-green-100">
          <FileQuestionMark className="text-hajj-primary size-[50px]" />
        </EmptyMedia>
        <EmptyTitle>Aucune donnée disponible</EmptyTitle>
        <EmptyDescription className="text-hajj-primary">Rien à afficher pour le moment</EmptyDescription>
      </EmptyHeader>
    </Empty>
  );
};

export default EmptyCard;
